/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const storeFinder = {
  storeFinder: {
    openUntil: 'Aberto até',
    closed: 'Fechado',
    back: 'Atrás',
    call: 'Chamar',
    getDirections: 'Obter direções',
    ariaLabelGetDirections: 'Obter direções, this link abre em nova janela',
    ariaLabelCountriesCount: 'Lojas em {{ count }} países encontrados',
    listView: 'Visualização de lista',
    mapView: 'Visualização de mapa',
    noStoresFound: 'Nenhuma loja encontrada.',
    storeHours: 'Horário de funcionamento da loja',
    storeFeatures: 'Recursos da loja',
    storeFinder: 'Localizador de lojas',
    storesFound: '{{ count }} Loja encontrada',
    storesFound_other: '{{ count }}Lojas encontradas',
    fromStoresFound: 'from {{ count }} Loja encontrada',
    fromStoresFound_other: 'from {{ count }} Lojas encontradas',
    findStore: 'Encontre uma loja',
    useMyLocation: 'Usar minha localização',
    viewAllStores: 'Ver todas as lojas',
    contactUs: 'Contate-nos',
    searchBox: 'Código postal, cidade ou endereço',
    backToList: 'Voltar à lista',
    noStoresMessage: 'Nenhuma loja found.in o banco de dados...',
    geolocationNotEnabled:
      'Lojas próximas não podem ser localizadas. O consentimento de geolocalização não foi habilitado',
    searchNearestStores: 'Encontre uma lojas más cercanas',
    searchBoxLabel: 'Digite o CEP, cidade ou endereço',
  },
};
